import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';
import YoutubeContainer from '../components/youtube/YoutubeContainer';
import ImageGallery from '../components/Gallery/ImageGallery';
export default function EmsculptNEOMuscleBuildAndFatReduction() {
    const { t } = useTranslation();
    const accodirons = [
        {
            title: t('what'),
            content: t('emsculpt_neo_muscle_build_and_fat_reduction.what')
        },
        {
            title: t('how'),
            content: t('emsculpt_neo_muscle_build_and_fat_reduction.how')
        },
        {
            title: t('benefits'),
            content: t('emsculpt_neo_muscle_build_and_fat_reduction.benefits')
        },
        {
            title: t('pairing'),
            content: t('emsculpt_neo_muscle_build_and_fat_reduction.pairs')
        },
        {
            title: t('when_expected_results'),
            content: t('emsculpt_neo_muscle_build_and_fat_reduction.expected_results')
        },
        {
            title: t('results'),
            content: t('emsculpt_neo_muscle_build_and_fat_reduction.results')
        },
    ]

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('emsculpt_neo_muscle_build_and_fat_reduction.time')
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('emsculpt_neo_muscle_build_and_fat_reduction.discomfort')
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('emsculpt_neo_muscle_build_and_fat_reduction.downtime')
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('emsculpt_neo_muscle_build_and_fat_reduction.sessions')
        }
    ]

    const gallery = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f355661f16b9.52815430.png`,
        },
        {
             imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f3556a829682.97677717.png`,
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f355ba946526.53966048.jpg`,
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f355bd7a8fc2.44927710.jpg`,
        },
         {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f354cdd1b5b1.03896458.jpg`,
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f354cdd1a169.55108323.jpg`,
        }
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <YoutubeContainer videoId={'GolBEIlA-a4'} />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    // titleSize={{ md: 12, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: "EMSCULPT NEO",
                        description: t('emsculpt_neo_muscle_build_and_fat_reduction.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMSCULPT NEO")}`,
                        learn: "",
                        price: `${t('emsculpt_neo_muscle_build_and_fat_reduction.mainPrice')}`,
                        doctorIncluded: true
                    }}
                />
            </Box>

            <Box marginTop={{md: '100px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            {/* <Grid container className='generalContainer' marginX={'auto'} spacing={2} marginTop={{md: '70px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontSize={{md: '1.125rem', xs: '1rem'}} fontWeight={'bold'}>What Involves</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{md: '30px', xs: '1.125rem'}}>
                        After consultation and area selection, applicators are placed directly on the skin. Each session lasts about 30 minutes and feels like an intense workout combined with gentle warmth.
                    </Typography>
                </Grid>
            </Grid> */}

            <Box>
                <Box marginTop={{md: '225px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { xl: '1340px', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '90px', xs: '50px' }}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            imageSize: { md: 6, xs: 12 },
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMSCULPT NEO")}`,
                            type: t('emsculpt_neo_muscle_build_and_fat_reduction.tech'),
                            // learn: '/',
                            title: 'BTL - EMSCULPT NEO',
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/EMSCUPLT.png`,
                            flexDirection: { md: 'row-reverse', xs: 'column-reverse' },
                            description: t('emsculpt_neo_muscle_build_and_fat_reduction.techDesc')
                        }}
                        extraStyle={{
                            backgroundColor: '#1E353D'
                        }}
                    />
                </Box>
            </Box>

            <Grid container gap={{md: '80px', xs: '30px'}} className="generalContainer" sx={{ marginX: 'auto' }} marginTop={{md: '123px', xs: '50px'}}>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>
            <Box paddingTop={{ md: '120px', xs: '50px' }} className="generalContainer" mx={'auto'} paddingBottom={{ md: '120px', xs: '50px' }}>
                <ImageGallery gallery={gallery} />
            </Box>
            {/* <Box bgcolor={'#DBDAD9'} marginTop={{md: '153px', xs: '50px'}} paddingTop={{ md: '120px', xs: '50px' }} paddingBottom={{md: '188px', xs: '50px'}}>
               <Box className="generalContainer" marginX={'auto'} gap={'90px'} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            type: 'Pairing',
                            title: 'Emtone Cellulite Smoothing',
                            description: 'Emsculpt NEO is fantastic on its own for body shaping, but it can also be part of a holistic plan. For example, we often combine it with Emtone Cellulite Smoothing on the thighs or Exion RF Skin-Tightening on the abdomen to address skin laxity while we build muscle and burn fat underneath. Maintaining a healthy diet and exercise routine will of course enhance and prolong the results think of Emsculpt NEO as the booster to get you faster to your body goals that gym and diet alone struggle with.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/fractional-co2-resurfacing",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            type: 'Pairing',
                            title: 'Exion RF SkinTightening',
                            description: 'Complements Emsculpt NEO by firming and refining areas where fat has been reduced. AI-controlled radiofrequency stimulates collagen and elastin to tighten the skin on the abdomen, arms, and knees, helping contours appear smoother and more defined.',
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box> */}
        </Box>
    )
}